// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lzxgwibluhdmqbyiuipn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6eGd3aWJsdWhkbXFieWl1aXBuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxODAyMTUsImV4cCI6MjA2Mzc1NjIxNX0.6TtlGduKzTCH8J_fpDOZBxOOodODyvqC-12JVWhWs_M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);